module.exports = __webpack_public_path__ + "static/media/expressjsLogo.87a0e081.png";